/**
 * This module is in charge of controlling inputs for locations.
 */
(function() {

  "use strict";

  var STATION_SEARCH_RADIUS = 500;

  var DEFAULT_CONFIG = {
    hideOtherPanels: jQuery.noop,
    showPanels: jQuery.noop
  };


  var ID = 0;

  define('fg-arv/components/infoJourney',['fg-arv/utils', 'fg-arv/components/stepByStep', 'fg-arv/libs/mustache', 'fg-arv/components/legend'],
    function(utils, stepByStep, Mustache, legend) {


      var module = {
        createComponent: function(config) {
          var that = this;
          var mapView = config.mapView;
          var container = utils.getPropertyValue(config, 'container');
          if (container) {
            var id = createDomID();
            var conf = jQuery.extend({
              id: id
            }, DEFAULT_CONFIG, config);

            var template = "<div id='" + id + "' class='panel-route '></div>",
              component, templateCollapse, templateExpand, dataInfoJourney;

            container.append(template);
            var componentElement = jQuery('#' + id);

            component = {
              getID: function() {
                return id;
              },
              getData: function() {
                return dataInfoJourney;
              },
              getRoute: function() {
                return conf.route;
              },
              expand: function() {
                componentElement.removeClass('collapse-route');
                componentElement.addClass('expand-route');
                componentElement.html(templateExpand);
                component.focusOnRouteListen();
                component.clickOnRouteListen();
                componentElement.find('.stepByStep-button').click(function() {
                  if (jQuery(this).hasClass('open')) {
                    componentElement.find('.stepByStep-button').removeClass('open');
                    componentElement.find('.stepByStep-button').addClass('zmdi-caret-down');
                    componentElement.find('.stepByStep-button').removeClass('zmdi-caret-up');
                    componentElement.find('.steps-container').html('');
                  } else {
                    componentElement.find('.stepByStep-button').addClass('open');
                    componentElement.find('.stepByStep-button').addClass('zmdi-caret-up');
                    componentElement.find('.stepByStep-button').removeClass('zmdi-caret-down');
                    stepByStep.createComponent({
                      container: componentElement.find('.steps-container'),
                      heading: conf.heading,
                      widget: conf.widget,
                      route: conf.route,
                      template: templateExpand,
                      data: component.getData()
                    });
                    var distanceInfo = jQuery(componentElement.find('.steps-container .distance-info')[
                      0]).html();
                    var unitInfo = distanceInfo.split(" ")[1];
                    var type = null;
                    if (unitInfo === "mi" || unitInfo === "ft") {
                      type = "imperial";
                    } else if (unitInfo === "km" || unitInfo === "m") {
                      type = "metric";
                    }
                    if (conf.widget.unitSystemComponent.getValue() !== type) {
                      conf.widget.journeysComponent.changeUnitSystem(conf.widget.unitSystemComponent.getValue(),
                        '.steps-container .distance-info');
                    }
                  }
                });
              },
              favouriteRoute: function() {
                if (component.getRoute().favorite) {
                  component.checkAsFavorite();
                }
                var journeyPanel = conf.getJourneyComponent();
                componentElement.find('.favorite-button').click(function() {
                  if (jQuery(this).hasClass('favourite')) {
                    journeyPanel.removeFavoriteRoute(component.getRoute());
                  } else {
                    journeyPanel.saveFavoriteRoute(component.getRoute());
                  }
                  journeyPanel.resetPanel();
                });
              },
              tooltipCarInfo: function() {
                jQuery('[data-toggle="popover"]').popover();
                jQuery('body').on('click', function(e) {
                  jQuery('[data-toggle="popover"]').each(function() {
                    //the 'is' for buttons that trigger popups
                    //the 'has' for icons within a button that triggers a popup
                    if (!jQuery(this).is(e.target) && jQuery(this).has(e.target).length === 0 &&
                      jQuery('.popover').has(e.target).length === 0) {
                      jQuery(this).popover('hide');
                    }
                  });
                });
              },
              unCheckAsFavorite: function() {
                componentElement.find('.favorite-button').removeClass('favourite');
                componentElement.find('.favorite-button').removeClass('zmdi-favorite');
                componentElement.find('.favorite-button').addClass('zmdi-favorite-outline');
              },
              checkAsFavorite: function() {
                componentElement.find('.favorite-button').removeClass('zdmi-favorite-outline');
                componentElement.find('.favorite-button').addClass('zmdi-favorite');
                componentElement.find('.favorite-button').addClass('favourite');
              },
              focusOnRouteListen: function() {
                componentElement.mouseenter(function() {
                  component.focusOnRoute();
                });
                componentElement.mouseleave(function() {
                  component.leaveRoute();
                });
              },
              focusOnRoute: function() {
                componentElement.addClass('focused');
                mapView.focusOnRoute(conf.route);
              },
              leaveRoute: function() {
                componentElement.removeClass('focused');
                mapView.leaveRoute();
              },
              clickOnRouteListen: function() {
                componentElement.click(function() {
                  conf.clickCallback();
                  component.clickOnRoute();
                });
              },
              clickOnRoute: function() {
                componentElement.addClass('selected');
                mapView.selectRoute(conf.route);
              }

            };

            module.getInfoRoute(conf).done(function(data) {
              dataInfoJourney = data;
              templateExpand = Mustache.render(createTemplate(conf), dataInfoJourney);
              component.expand();
              component.favouriteRoute();
              component.tooltipCarInfo();
            });
            return component;
          }
        },

        //prepare data for Mustache template
        getInfoRoute: function(conf) {
          var deferredData = new jQuery.Deferred(),
            stepsDeferred = [];
          var route = conf.route.legs[0];
          var styles = legend.getStyles();
          var infoRouteDeferred = new jQuery.Deferred();
          var _this = this;
          var infoRoute = {
            isLast: conf.isLast,
            routeColor: conf.color,
            index: conf.index + 1,
            routeCount: conf.index,
            summary: conf.route.summary,
            duration: route.duration ? route.duration.text : '',
            distance: route.distance ? route.distance.text : '',
            start_address: route.start_address,
            end_address: route.end_address,
            unique_values: [],
            unique_obj: {},
            transbords: [],
            start_time_dateObject: route.departure_time ? route.departure_time.value : ''
          };
          var styles = legend.getStyles();

          this.getStartEndTimeAndAgencies(conf).then(function(times) {
            var nStepsWalking = 0,
              nStepsDriving = 0,
              s, isLast;
            infoRoute.start_time = times.startTime.value;
            infoRoute.end_time = times.endTime.value;
            if (times.startTime.gmt !== times.endTime.gmt) {
              infoRoute.timezoneChanged = true;
            }
            for (s = 0; s < route.steps.length; s++) {
              isLast = s < route.steps.length - 1 ? false : true;
              stepsDeferred.push(_this.getInfoTransbord(nStepsWalking, nStepsDriving, s, route.steps[s],
                isLast, infoRoute,
                styles, route.steps, times.startTime.gmt));
            }
            if (infoRoute.onlyOneMode) {
              var dateDeparture = conf.widget.dateComponent.getDate();
              var timeDeparture = conf.widget.timeComponent;
              var inputTime = new Date(dateDeparture.getFullYear(), dateDeparture.getMonth(), dateDeparture
                .getDate(), timeDeparture.getHours(), timeDeparture.getMinutes());
              if (conf.arrivalTime) {
                infoRoute.end_time = utils.normalizeTime(inputTime.getTime());
                infoRoute.start_time = utils.normalizeTime(inputTime.getTime() - (route.duration.value *
                  1000));
              } else {
                infoRoute.start_time = utils.normalizeTime(inputTime.getTime());
                infoRoute.end_time = utils.normalizeTime(inputTime.getTime() + (route.duration.value * 1000));
              }
              infoRoute.transbords[0].departure_time = infoRoute.start_time;
            }
            jQuery.when.apply(jQuery, stepsDeferred).done(function() {
              infoRouteDeferred.resolve(infoRoute);
            });
          });
          return infoRouteDeferred.promise();
        },
        getStartEndTimeAndAgencies: function(conf) {
          var route = conf.route.legs[0],
            startTimeDeferred = new jQuery.Deferred(),
            endTimeDeferred = new jQuery.Deferred(),
            deferreds = [],
            routeTimedeferred = new jQuery.Deferred(),
            departure_time = route.departure_time ? route.departure_time : '',
            arrival_time = route.arrival_time ? route.arrival_time : '',
            departureTime, arrivalTime;
          if (!route.departure_time && !route.arrival_time) {
            if (conf.arrivalTime) {
              arrivalTime = conf.arrivalTime;
              arrival_time = {
                value: arrivalTime.getTime()
              };
              departure_time = {
                value: (arrivalTime.getTime() - (route.duration.value * 1000))
              };
            } else {
              departureTime = conf.departureTime;
              departure_time = {
                value: departureTime.getTime()
              };
              arrival_time = {
                value: (departureTime.getTime() + (route.duration.value * 1000))
              };
            }
          }
          utils.getLocalTime(route.start_location, departure_time, conf.widget.apiObject).then(function(time) {
            startTimeDeferred.resolve(time);
          });

          deferreds.push(startTimeDeferred.promise());

          utils.getLocalTime(route.end_location, arrival_time, conf.widget.apiObject).then(function(time) {
            endTimeDeferred.resolve(time);
          });

          deferreds.push(endTimeDeferred.promise());

          jQuery.when.apply(jQuery, deferreds).done(function(start_time, end_time) {
            routeTimedeferred.resolve({
              startTime: start_time,
              endTime: end_time
            });
          });
          return routeTimedeferred.promise();
        },
        getInfoTransbord: function(nStepsWalking, nStepsDriving, s, step, isLast, infoRoute, styles, steps, gmt) {
          var transbord, getDepartTimePromise, getArrivalTimePromise, deferredsTransbord = [],
            stepDeferred = new jQuery.Deferred();

          transbord = {
            mode: step.travel_mode,
            step_distance: step.distance.text,
            step_duration: step.duration.text,
            instructions: step.instructions,
            departure_station: s === 0 ? infoRoute.start_address : '',
            departure_time: s === 0 ? infoRoute.start_time : '',
            arrival_station: s === 0 ? infoRoute.end_address : '',
            arrival_time: isLast ? infoRoute.end_time : '',
            isLast: isLast,
            index: s
          };

          switch (step.travel_mode) {
            case 'WALKING':
              var location, time;
              if (s != 0) {
                if (steps[s - 1].arrival_station) {
                  transbord.departure_station = steps[s - 1].arrival_station;
                } else if (steps[s - 1].transit) {
                  var beforeIndex = s - 1;
                  transbord.departure_station = steps[beforeIndex].transit.arrival_stop.name;
                  location = steps[beforeIndex].transit.arrival_stop.location;
                  time = steps[beforeIndex].transit.arrival_time;

                  if (beforeIndex < 2) {
                    //check if previous transbord is delayed
                    if (infoRoute.isDelayed) {
                      time = {
                        value: infoRoute.delayTransbordDepartureTimeValue + steps[beforeIndex].duration.value *
                          1000
                      };
                      transbord.arrivalDelayed = true;
                    }
                  }

                  if (!transbord.departure_time) {
                    getDepartTimePromise = new jQuery.Deferred();
                    utils.getLocalTime(location, time)
                      .then(function(time) {
                        var offsetHours;
                        if (time.gmt !== gmt) {
                          offsetHours = (parseInt(gmt.replace('GMT', '')) - parseInt(
                            time.gmt.replace('GMT', '')));
                          transbord.departure_time = utils.addHour(time.value, offsetHours);
                        } else {
                          transbord.departure_time = time.value;
                        }
                        transbord.departure_gmt = time.gmt;
                        getDepartTimePromise.resolve(time);
                      });
                    deferredsTransbord.push(getDepartTimePromise.promise());
                  }
                }
              }

              transbord.icon = '/dist/images/walk-mode.png';
              transbord.class = 'walking';
              if (!infoRoute.unique_obj.walk) {
                infoRoute.unique_obj.walk = {
                  icon: transbord.icon,
                  title: 'Walking'
                };
                infoRoute.unique_values.push(infoRoute.unique_obj.walk);
              }
              transbord.maneuver = step.maneuver;
              transbord.lineColor = styles[step.travel_mode] && styles[step.travel_mode].strokeColor ? styles[
                step.travel_mode].strokeColor : false;
              infoRoute.walking_time += step.duration.value;
              nStepsWalking++;

              break;
            case 'TRANSIT':
              getDepartTimePromise = new jQuery.Deferred();
              utils.getLocalTime(step.transit.departure_stop.location, step.transit.departure_time)
                .then(function(time) {
                  transbord.departure_time = time.value;
                  transbord.departure_gmt = time.gmt;
                  getDepartTimePromise.resolve(time);
                });
              deferredsTransbord.push(getDepartTimePromise.promise());

              transbord.departure_station = step.transit.departure_stop ? step.transit.departure_stop.name :
                '';

              if (!transbord.arrival_time) {
                getArrivalTimePromise = new jQuery.Deferred();
                utils.getLocalTime(step.transit.arrival_stop.location, step.transit.arrival_time)
                  .then(function(time) {
                    transbord.arrival_time = time.value;
                    transbord.arrival_gmt = time.gmt;
                    getArrivalTimePromise.resolve(time);
                  });
                deferredsTransbord.push(getArrivalTimePromise.promise());
              }
              transbord.arrival_station = step.transit.departure_stop ? step.transit.departure_stop.name :
                '';
              transbord.mode = step.transit.line.vehicle.type;
              transbord.line = step.transit.line.short_name;
              transbord.lineColor = infoRoute.routeColor;
              transbord.color = step.transit.line.color ? step.transit.line.color : '#fff';
              transbord.text_color = step.transit.line.text_color ? step.transit.line.text_color : '#444';
              transbord.agency = step.transit.line.agencies[0].name;
              transbord.icon = step.transit.line.vehicle.icon ? step.transit.line.vehicle.icon :
                step.transit.line.vehicle.icon;

              transbord.title = step.transit.line.vehicle.name;

              //error in the london bus icon url provided by google
              if (transbord.title === 'Train') {
                transbord.icon = '/dist/images/train-mode.png';
                transbord.class = 'train';
              } else if (transbord.title === 'Bus') {
                transbord.icon = '/dist/images/bus-mode.png';
                transbord.class = 'bus';
              } else if (transbord.icon.search('uk-london-bus') !== -1) {
                transbord.icon = 'https://maps.gstatic.com/mapfiles/transit/iw2/6/uk-london-bus.png';
                transbord.class = 'london-bus';
              } else if (transbord.title === 'Subway') {
                transbord.icon = '/dist/images/tube-mode.png';
                transbord.class = 'subway';
              } else if (transbord.title === 'Taxi') {
                transbord.icon = '/dist/images/taxi-mode.png';
                transbord.class = 'taxi';
              } else if (transbord.title === 'Plane') {
                transbord.icon = '/dist/images/fly-mode.png';
                transbord.class = 'plane';
              } else if (transbord.title === 'Ferry') {
                transbord.icon = '/dist/images/ferry-mode.png';
                transbord.class = 'ferry';
              }
              if (!infoRoute.unique_obj[step.transit.line.short_name]) {
                infoRoute.unique_obj[step.transit.line.short_name] = {
                  icon: transbord.icon,
                  color: transbord.color,
                  text_color: transbord.text_color,
                  line: transbord.line,
                  agency: transbord.agency,
                  title: transbord.title
                };
                infoRoute.unique_values.push(infoRoute.unique_obj[step.transit.line.short_name]);
              }
              if (s < 2) {

                if (s === 0) {
                  infoRoute.noDelayStartValue = step.transit.departure_time.value.getTime();
                  infoRoute.delayTransbordDepartureTimeValue = infoRoute.start_time_dateObject.getTime();
                } else if (s === 1) {
                  infoRoute.noDelayStartValue = step.transit.departure_time.value.getTime() - steps[s - 1].duration
                    .value * 1000;
                  infoRoute.delayTransbordDepartureTimeValue = infoRoute.start_time_dateObject.getTime() +
                    steps[s - 1].duration.value * 1000;
                }
                //check if it's delayed
                var delayTime = infoRoute.start_time_dateObject.getTime() - infoRoute.noDelayStartValue;
                if (delayTime > 60000) {
                  infoRoute.isDelayed = true;
                  getDepartTimePromise = new jQuery.Deferred();
                  utils.getLocalTime(step.transit.departure_stop.location, {
                      value: new Date(infoRoute.delayTransbordDepartureTimeValue)
                    })
                    .then(function(time) {
                      var offsetHours;
                      if (time.gmt !== gmt) {
                        offsetHours = (parseInt(gmt.replace('GMT', '')) - parseInt(
                          time.gmt.replace('GMT', '')));
                        transbord.delayDepartureTime = utils.addHour(time.value, offsetHours);
                      } else {
                        transbord.delayDepartureTime = time.value;
                      }
                      getDepartTimePromise.resolve(time);
                    });
                  deferredsTransbord.push(getDepartTimePromise.promise());
                  if (isLast) {
                    infoRoute.delay_end_time = true;
                  }

                }
              }
              break;
            case 'DRIVING':
              transbord.icon = '/dist/images/car-mode.png';
              transbord.class = 'car';
              transbord.lineColor = infoRoute.routeColor;
              if (!infoRoute.unique_obj.drive) {
                infoRoute.unique_obj.drive = {
                  icon: transbord.icon,
                  color: transbord.color,
                  title: 'Driving'
                };
                infoRoute.unique_values.push(infoRoute.unique_obj.drive);
              }
              transbord.maneuver = step.maneuver;
              nStepsDriving++;
              break;
          }


          jQuery.when.apply(jQuery, deferredsTransbord).done(function() {
            if (!infoRoute.departure_info && step.travel_mode === 'TRANSIT') {
              infoRoute.departure_info = {
                station: transbord.departure_station,
                time: transbord.departure_time
              };
            }
            infoRoute.transbords[transbord.index] = transbord;
            if ((isLast && (infoRoute.transbords.length === nStepsWalking)) || infoRoute.transbords.length ===
              nStepsDriving) {
              infoRoute.onlyOneMode = true;
              infoRoute.carAdvertisement = nStepsDriving > 0 ?
                'Excludes traffic delays and rest/break stops' : false;
            }
            if (isLast) {
              var hours = new Date(infoRoute.walking_time * 1000).getHours() - 1,
                minutes = new Date(infoRoute.walking_time * 1000).getMinutes();
              infoRoute.walking_time = {
                hours: hours > 0 ? hours + ' h' : '',
                minutes: minutes > 0 ? minutes + ' min' : ''
              };
            }
            stepDeferred.resolve();
          });



          return stepDeferred.promise();
        },

        parseHoursAndMinutes: function(value) {
          var res = '',
            minutes, hours, days;

          minutes = Math.floor(value / 60);
          hours = Math.floor(minutes / 60);
          days = Math.floor(hours / 24);
          hours = hours - (days * 24);
          minutes = minutes - (days * 24 * 60) - (hours * 60);

          res += days !== 0 ? days + ' d ' : '';
          res += hours !== 0 ? hours + ' h ' : '';
          res += minutes !== 0 ? minutes + ' min' : '';

          return res;
        }


      };

      return module;

      //*********************************************************

      function createTemplate(config) {

        return "<div class='route-info-panel'><div class='row row-head'>" +
          "<div class='col-xs-3'><div class='id-route marker-{{routeCount}}' style='border-color:{{routeColor}}'><span>Route {{index}}</span></div></div>" +
          "<div class='left col-xs-9 duration'>{{duration}} {{#carAdvertisement}}<i class='zmdi zmdi-info-outline car-advertisement' title='{{carAdvertisement}}' data-toggle='popover' data-placement='top' data-trigger='hover click'></i>{{/carAdvertisement}}</div>" +
          "</div>" +
          "<div class='row row-transbord wrap'><div class='{{#onlyOneMode}}pull-left{{/onlyOneMode}} panel-transbords col-xs-9 wrap'>" +
          "{{#onlyOneMode}}<div class='one-mode'><img class='{{transbords.0.class}}' title='{{unique_values.0.title}}' src={{transbords.0.icon}}>  {{summary}} </div><div class='distance-info'>{{distance}}</div> {{/onlyOneMode}}" +
          "{{^onlyOneMode}}{{#transbords}}<div class='pull-left text-center'><div><img class='{{class}}' title='{{title}}' src={{icon}}></div>" +
          "<div class='distance-info'>{{step_distance}}</div></div><div class='pull-left separator'>{{^isLast}}<div class='arrow pull-left'></div>{{/isLast}}</div>{{/transbords}}{{/onlyOneMode}}" +
          "</div>" +
          "<div class='panel-journey-buttons col-xs-3 right'>" +
          "<a title='Step by step' href='#' class='info-journey-button zmdi zmdi-caret-down zmdi-hc-3x stepByStep-button'></a>" +
          "</div>" +
          "</div>" +
          "</div>" +
          "<div class='steps-container'></div>";


      }



      function createDomID() {
        var i = ++ID;
        return "fg-arv-jp-info-journey-" + i;
      }


    });

})();

